import React from 'react';
import PropTypes from 'prop-types';
// import { withStyles } from '@material-ui/core/styles';
// import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogTitle from '@material-ui/core/DialogTitle';
import {
  withStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";

import { FormControl } from '@material-ui/core';
import { TextField } from '@material-ui/core';

import Button from './RainbowButton';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 400,
  },
});

class DialogInput extends React.Component {
  state = {
    open: false,
    age: '',
  };

  handleChange = name => event => {
    this.setState({ [name]: Number(event.target.value) });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleOk = () => {
    this.props.onConfirm();
    this.setState({ open: false });
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <Button onClick={this.handleClickOpen}>Edit</Button>
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          open={this.state.open}
          onClose={this.handleClose}
        >
          <DialogTitle>Input New Title:</DialogTitle>
          <DialogContent style={{minWidth: '400px'}}>
            <form className={classes.container}>
              <FormControl className={classes.formControl} fullWidth>
                <TextField
                  fullWidth
                    id="title"
                    label="Title"
                    onChange={this.props.onChange}
                />
              </FormControl>
            {/*  <FormControl className={classes.formControl}>
                <TextField
                    id="other"
                    label="Other"
                    onChange={this.props.onChange1}
                />
              </FormControl> */}
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleOk} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

DialogInput.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DialogInput);